import React from "react";
import { Icons } from "../../atoms/Icons";
import { Card, Col } from "react-bootstrap";
import "./qrcode-status-modal.scss";
import { Link } from "react-router-dom";

const QRCodeStatusModal = (props) => {
  return (
    <div className="qr-code-status-modal-container">
      <Link to="" className="qr-status-close">
        <Icons
          iconname="close-large"
          variant="icon-sixteen-px"
          clickHandler={props.handleCloseButton}
        />
      </Link>
      {props.status === "Success" ? (
        <Col xs={12}>
          <Card className="status-card pt-4">
            <Icons iconname="tick" />
            <Card.Body className="p-0">
              <Card.Title className="status-title">
                {props?.statusTitle ? props?.statusTitle : ""}
              </Card.Title>
              <Card.Text className="status-text">
                {props?.statusText ? props?.statusText : ""}
              </Card.Text>
            </Card.Body>
          </Card>
        </Col>
      ) : props.status === "Error" ? (
        <Col xs={12}>
          <Card className="status-card pt-4">
            <Icons iconname="cross" />
            <Card.Body className="p-0">
              <Card.Title className="status-title">
                {props?.statusTitle ? props?.statusTitle : ""}
              </Card.Title>
              <Card.Text className="status-text">
                {props?.statusText ? props?.statusText : ""}
              </Card.Text>
            </Card.Body>
          </Card>
        </Col>
      ) : (
        ""
      )}
    </div>
  );
};

export default QRCodeStatusModal;
